import type { FontWeight, TextSize } from "@homeinstead/schemas";

import { resolveTextSizeClass, TEXT_SIZE_CLASS } from "@homeinstead/schemas";

export { resolveTextSizeClass, TEXT_SIZE_CLASS };

export const FONT_WEIGHT_CLASS: Record<FontWeight, string> = {
  bold: "font-bold",
  regular: "font-normal",
  semibold: "font-semibold",
};

export function resolveFontWeightClass(
  fontWeight: string | null | undefined,
  defaultWeight: FontWeight = "semibold",
): string {
  return (
    FONT_WEIGHT_CLASS[(fontWeight ?? defaultWeight) as FontWeight] ??
    FONT_WEIGHT_CLASS[defaultWeight]
  );
}

export type TextAlignment = "none" | "left" | "center" | "right";

export const TEXT_ALIGNMENT_CLASS: Record<TextAlignment, string> = {
  center: "text-center",
  left: "text-left",
  none: "",
  right: "text-right",
};

export function resolveTextAlignmentClass(
  textAlignment: string | null | undefined,
  defaultAlignment: TextAlignment = "left",
): string {
  return (
    TEXT_ALIGNMENT_CLASS[
      (textAlignment ?? defaultAlignment) as TextAlignment
    ] ?? TEXT_ALIGNMENT_CLASS[defaultAlignment]
  );
}

/**
 * Only "plus-jakarta" is supported now that the CMS font picker has been
 * removed, but this keeps the same map + resolver shape as the other
 * resolve*Class helpers in this file in case a second option returns.
 */
type LabelFontFamily = "plus-jakarta";

export const LABEL_FONT_FAMILY_CLASS: Record<LabelFontFamily, string> = {
  "plus-jakarta": "font-jakarta",
};

export function resolveLabelFontFamilyClass(
  fontFamily?: string | null,
  defaultFamily: LabelFontFamily = "plus-jakarta",
): string {
  return (
    LABEL_FONT_FAMILY_CLASS[(fontFamily ?? defaultFamily) as LabelFontFamily] ??
    LABEL_FONT_FAMILY_CLASS[defaultFamily]
  );
}

export function resolveFieldsetLegendClasses({
  fontWeight,
  spacingClass = "mb-4",
  textSize,
}: {
  fontWeight: string | null | undefined;
  spacingClass?: string;
  textSize: string | null | undefined;
}): string {
  return [
    spacingClass,
    resolveLabelFontFamilyClass(),
    resolveTextSizeClass(textSize as TextSize | null, "xl"),
    resolveFontWeightClass(fontWeight, "regular"),
  ].join(" ");
}

export type ContentAlignment = "left" | "center" | "right";

const CONTENT_ALIGNMENT_CLASS: Record<ContentAlignment, string> = {
  center: "mx-auto",
  left: "mr-auto",
  right: "ml-auto",
};

export function resolveContentAlignmentClass(
  alignment: string | null | undefined,
  defaultAlignment: ContentAlignment = "left",
): string {
  return (
    CONTENT_ALIGNMENT_CLASS[
      (alignment ?? defaultAlignment) as ContentAlignment
    ] ?? CONTENT_ALIGNMENT_CLASS[defaultAlignment]
  );
}
